import { useCallback } from 'react';
import { Button } from 'antd';
import { HotkeyTip } from './hotkey';

export interface DialogFooterProps {
  okText: string;
  cancelText?: string;
  onOk: () => void;
  onCancel: () => void;
  okLoading?: boolean;
  okDisabled?: boolean;
  okDanger?: boolean;
  /** Ставить курсор на главную кнопку при открытии диалога (`Enter` подтверждает). Не нужно,
   *  когда в диалоге есть поле с `autoFocus`: курсор уже в нём. По умолчанию включено. */
  focusOk?: boolean;
}

/**
 * Подвал диалога с клавиатурным поведением: «Отмена» с подсказкой `Esc` (сам `Esc` закрывает
 * диалог через `onCancel` у `Modal`), главная кнопка получает курсор при открытии. Работает
 * вместе с `destroyOnHidden` на `Modal` — содержимое создаётся заново при каждом открытии, поэтому
 * курсор встаёт на кнопку каждый раз. Фокус — кадром позже монтирования: контейнер портала в
 * момент монтирования ещё не вставлен в документ и `autoFocus` не действует.
 */
export function DialogFooter({ okText, cancelText = 'Отмена', onOk, onCancel, okLoading, okDisabled, okDanger, focusOk = true }: DialogFooterProps) {
  const focusButton = useCallback(
    (el: HTMLButtonElement | null) => {
      if (el && focusOk) requestAnimationFrame(() => el.focus());
    },
    [focusOk],
  );
  return (
    <>
      <HotkeyTip label={cancelText} combo="Escape">
        <Button onClick={onCancel}>{cancelText}</Button>
      </HotkeyTip>
      <Button ref={focusButton} type="primary" danger={okDanger} loading={okLoading} disabled={okDisabled} onClick={onOk}>
        {okText}
      </Button>
    </>
  );
}
